module.exports = __webpack_public_path__ + "static/media/key.9d6e7166.svg";